import { useRef, useState } from 'react';

export type UserMenuState = {
  open: boolean;
  triggerRef: React.RefObject<HTMLButtonElement | null>;
  rect: DOMRect | null | undefined;
  toggle: () => void;
  close: () => void;
};

export function useUserMenu(): UserMenuState {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);
  const rect = open ? triggerRef.current?.getBoundingClientRect() : null;
  return {
    open,
    triggerRef,
    rect,
    toggle: () => setOpen((o) => !o),
    close: () => setOpen(false),
  };
}
